// extracted by mini-css-extract-plugin
export default {"Icon":"icon_Icon__7+HKy"};